import sample_1 from './classiclines.jpg';

export const classicLineSImpressions = {
    sample_1,
};
